import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgAward = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.71 9.156a5.656 5.656 0 1 1 11.312 0 5.656 5.656 0 0 1-11.313 0M11.365 2a7.156 7.156 0 0 0-5.75 11.418l-3.292 4.124a1.476 1.476 0 0 0 .542 2.267l4.726 2.064h.001a1.52 1.52 0 0 0 1.257-.022 1.48 1.48 0 0 0 .752-.955l.002-.007 1.096-4.607a7.3 7.3 0 0 0 1.71-.045l1.116 4.654.002.007a1.46 1.46 0 0 0 .79.965l.013.006a1.48 1.48 0 0 0 1.212.002l4.694-2.063.012-.005a1.46 1.46 0 0 0 .816-1.01 1.43 1.43 0 0 0-.291-1.255l-3.46-4.402A7.156 7.156 0 0 0 11.366 2m4.964 12.31a7.2 7.2 0 0 1-2.467 1.555l1.108 4.618 4.616-2.028zM3.514 18.456l3.13-3.921a7.15 7.15 0 0 0 2.584 1.454l-1.07 4.496zm5.754-9.299a2.097 2.097 0 1 1 4.195 0 2.097 2.097 0 0 1-4.195 0m2.098-3.597a3.597 3.597 0 1 0 0 7.194 3.597 3.597 0 0 0 0-7.194"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgAward;
